import { Injectable } from '@angular/core';

@Injectable()
export class CycleModel {

  constructor() { }
  public lib_cycle:string;
  public id_cat_composition:string;
}
